package com.nonopn.skydome.common.app.pages.main.view.map

import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.ripple
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import com.nonopn.skydome.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.design.widgets.DefaultCard
import com.nonopn.skywatcher.design.widgets.defaultCardBackground
import de.drick.compose.hotpreview.HotPreview

@Composable
fun MapOverlayCard(
    modifier: Modifier,
    columnModifier: Modifier = Modifier.fillMaxSize(),
    onClick: (() -> Unit)? = null,
    content: @Composable () -> Unit
) {
    val color = defaultCardBackground()

    DefaultCard(
        modifier = modifier,
        backgroundColor = color,
        columnModifier = columnModifier.let {
            if (null != onClick) {
                it.clickable(
                    interactionSource = remember { MutableInteractionSource() },
                    indication = ripple(),
                    onClick = onClick
                )
            } else {
                it
            }
        }
    ) {
        content()
    }
}

@Composable
@HotPreview(widthDp = 150, heightDp = 50, darkMode = true)
@HotPreview(widthDp = 150, heightDp = 50, darkMode = false)
private fun Preview() {
    HotPreviewApp(Modifier.fillMaxSize(), isDarkTheme = isSystemInDarkTheme()) {
        MapOverlayCard(
            Modifier.fillMaxSize()
        ) {
            // nothing
        }
    }
}
